import { render } from "./EventStat.vue?vue&type=template&id=35e2f972&scoped=true"
import script from "./EventStat.vue?vue&type=script&lang=js"
export * from "./EventStat.vue?vue&type=script&lang=js"

import "./EventStat.vue?vue&type=style&index=0&id=35e2f972&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e2f972"]])

export default __exports__